<template>
    <div>
        <el-table ref="tableRef" border stripe checkBox :height="treeTableHeight" :data="tablelist" @selection-change="handleSelectionChange">
            <template v-for="(v,k) in columns">
                <el-table-column :type="v.type" :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" ></el-table-column>
            </template>
        </el-table>
        <Pagination v-show="total>0" :total="total" :page="queryInfo.pagenum" :limit="queryInfo.pagesize" @updatePage="handleCurrentChange" @updateLimit="handleSizeChange" ></Pagination>
    </div>
</template>

<script>
    //import { mapGetters } from 'vuex'
    import {alertList} from '@/api/alert'
    import Pagination from '@/components/pagination/index'
    import {deviceInfo} from '@/api/device'
    export default {
        name: '',
        components: {
            Pagination
        },
        data() {
            return {
                tablelist: [],
                columns: [
                    {
                        type: 'selection',
                        width: '55px',
                        fixed: 'left'
                    }, {
                        label: '序号',
                        prop: 'id',
                        fixed: 'left',
                        width: '55px'
                    }, {
                        label: '报警id',
                        prop: 'aid',
                        width: '70px'
                    }, {
                        label: '报警时间',
                        prop: 'alertTime'
                    }, {
                        label: '详情',
                        prop: 'message'
                    }, {
                        label: '报警状态',
                        prop: 'state'
                    }, {
                        label: '是否手动处理',
                        prop: 'handle',
                    }, {
                        label: '处理时间',
                        prop: 'handleTime',
                        width: '120px'
                    }, {
                        label: '处理人',
                        prop: 'handleUser',
                        width: '120px'
                    }, {
                        label: '操作',
                        type: 'template',
                        template: 'action',
                        width: '290px',
                        fixed: 'right'
                    }
                ],
                treeTableHeight: 650,
                checkedList:[],
                queryInfo: {
                    pagesize: 10,
                    pagenum: 1,
                },
                total: 0,
                deviceInfo:{}
            }
        },
        methods: {
            getHeight() {
                // this.objstyle.height = window.innerHeight - 170 -55 -40 + 'px'
                if(this.total>0){
                    this.treeTableHeight = window.innerHeight - 60 -40 -32 + 'px'
                }else{
                    this.treeTableHeight = window.innerHeight - 60 -40 + 'px'
                }
            },
            handleSelectionChange(val) {
                this.checkedList = val
                console.log(this.checkedList)
            },
            handleSizeChange(newSize) {
                this.queryInfo.pagesize = newSize
                this.getAlertList()
            },
            /**
             * 分页组件切换页事件处理
             * @param newPage
             */
            handleCurrentChange(newPage) {
                this.queryInfo.pagenum = newPage
                this.getAlertList()
            },
            getAlertList(){
                let param = {}
                param.current = this.queryInfo.pagenum
                param.size = this.queryInfo.pagesize
                this.queryInfo.pid=this.deviceInfo.id
                alertList(param,this.queryInfo).then(response => {
                    if(response.code!=200)  {
                        this.getHeight()
                        return this.$message.error('获取报警列表失败！')
                    }
                    this.tablelist = response.data.records
                    this.total = response.data.total
                    console.log('获取报警列表',this.tablelist)
                    this.getHeight()
                })
            }
        },
        computed: {
           /* ...mapGetters([
                'deviceInfo'
            ])*/
        },
        created(){
            this.getHeight()
            let pid=Number(this.$route.query.pid)
            deviceInfo({pid:pid}).then(response => {
                if (response.code != 200) {
                    this.$message.error(response.msg)
                } else {
                    this.deviceInfo = response.data
                    window.addEventListener('resize', this.getHeight)
                    //BUSINESS-ALERT-PROJECT-PAGE
                    this.getAlertList()
                }
            })
        },
        activated(){
            this.$refs.tableRef.doLayout()
        }
    }
</script>

<style scoped>

</style>
